<template>
  <v-card

    class="mb-2"
  >
    <v-card-title class="pb-0" style="font-size: 1.0rem;">
      <v-flex v-if="hasHeader()" xs12>
        <div
          v-if="
            actList[0].verb == 'use_art' || actList[0].verb == 'product_like'
          "
        >
          <v-icon small :color="getIconColor">{{ getIcon }}</v-icon>
          <span v-if="actList.length == 1">
            <nuxt-link :to="localePath('/' + actList[0].actor.username + '/')">
              {{ actList[0].actor.profile.display_name }}
            </nuxt-link>
          </span>
          <span v-if="actList.length == 2">
            <nuxt-link :to="localePath('/' + actList[0].actor.username + '/')">
              {{ actList[0].actor.profile.display_name }}
            </nuxt-link>
            {{ $t('feed.activity.and') }}
            <nuxt-link :to="localePath('/' + actList[1].actor.username + '/')">
              {{ actList[1].actor.profile.display_name }}
            </nuxt-link>
          </span>
          <span v-if="actList.length > 2">
            <nuxt-link :to="localePath('/' + actList[0].actor.username + '/')">
              {{ actList[0].actor.profile.display_name }}
            </nuxt-link>
            ,
            <nuxt-link :to="localePath('/' + actList[1].actor.username + '/')">
              {{ actList[1].actor.profile.display_name }}
            </nuxt-link>
            {{ $t('feed.activity.and') }}
            {{ $tc('feed.activity.more', contribMore, { count: contribMore }) }}
          </span>
          {{ getAction }}
        </div>
        <div v-else>
          <v-icon small>{{ getIcon }}</v-icon>
          <nuxt-link :to="localePath('/' + actList[0].actor.username + '/')">
            {{ actList[0].actor.profile.display_name }}
          </nuxt-link>
          {{ getAction }}
        </div>
      </v-flex>
    </v-card-title>
    <v-card-title class="pt-0">
      <v-flex>
        <nuxt-link :to="localePath('/' + getCardUser.username + '/')">
          <v-avatar size="48px" class="mr-3" style="float:left;">
            <img
              v-lazy="
                getCardUser.profile.source || $store.state.placeholder.avatar_sm
              "
              alt="Avatar"
            />
          </v-avatar>
        </nuxt-link>
        <div>
          <h4 class="mb-0" style="line-height: 1.4rem;">
            {{ getCardUser.profile.display_name }} {{ getDescription }}
          </h4>
          <span style="color:rgba(0, 0, 0, 0.6);font-weight: 400">
            <small>{{ getTime }}</small>
          </span>
        </div>
      </v-flex>
    </v-card-title>
    <activity-card-asset
      v-if="assetGridList.indexOf(activity.verb) > -1"
      :activity="activity"
      :get-card-user="getCardUser"
      :get-object="getObject"
    />
    <activity-card-product
      v-if="productList.indexOf(activity.verb) > -1"
      :activity="activity"
      :get-card-user="getCardUser"
      :get-object="getObject"
    />
    <activity-card-sound
      v-if="soundList.indexOf(activity.verb) > -1"
      :activity="activity"
      :get-card-user="getCardUser"
      :get-object="getObject"
    />

    <activity-card-relationship
      v-if="activity.verb == 'relationship'"
      :activity="activity"
    />
    <v-card-actions
      v-if="activity.verb != 'relationship'"
      style="padding-left: 60px;"
    >
      <like-button :object="getObject(0)" v-if="isObject(getObject(0))"  />
      <!-- <share-button
        :url="getShare.url"
        :title="getShare.title"
        :description="getShare.description"
        :quote="getShare.description"
        :media="getShare.media"
      /> -->
      <!-- <remix-button
        v-if="productList.indexOf(activity.verb) > -1"
        :object="getObject(0)"
      /> -->
      <v-spacer />
      <more-button :object="getObject(0)" v-if="isObject(getObject(0))" />
    </v-card-actions>
  </v-card>
</template>

<script>
import ActivityCardAsset from '@/components/feed/ActivityCardAsset'
import ActivityCardProduct from '@/components/feed/ActivityCardProduct'
import ActivityCardSound from '@/components/feed/ActivityCardSound'
import ActivityCardRelationship from '@/components/feed/ActivityCardRelationship'
import ShareButton from '@/components/utils/buttons/ShareButton'
import LikeButton from '@/components/utils/buttons/LikeButton'
import MoreButton from '@/components/utils/buttons/MoreButton'
import RemixButton from '@/components/utils/buttons/RemixButton'

export default {
  name: 'ActivityCard',
  components: {
    ActivityCardAsset,
    ActivityCardProduct,
    ActivityCardSound,
    ActivityCardRelationship,
    ShareButton,
    LikeButton,
    MoreButton,
    RemixButton
  },
  props: {
    activity: {
      type: [Object],
      required: true,
      default: () => ({
        param: value,
        param2: value
      })
    }
  },
  data() {
    return {
      assetGridList: [
        'assetsasset_like',
        'assetsvg_like',
        'asset',
        'assetsvg',
        'asset_like'
      ],
      productList: ['product', 'product_like', 'remix', 'use_art', 'productsproduct_like'],
      soundList: ['sound', 'assetssound_like'],
      headerList: [
        'assetsasset_like',
        'asset_like',
        'assetsvg_like',
        'sound_like',
        'product_like',
        'use_art'
      ],
      description: {
        asset: {
          action: 'added',
          object: 'illustration'
        },
        assetsvg: {
          action: 'added',
          object: 'illustration'
        },
        sound: {
          action: 'added',
          object: 'sound'
        },
        assetssound: {
          action: 'added',
          object: 'sound'
        },
        relationship: {
          action: 'followed',
          object: 'person'
        },
        product: {
          action: 'published',
          object: 'story'
        },

        productsproduct_like: {
          action: 'liked',
          icon: 'mdiHeart',
          card_action: 'published',
          object: 'story'
        },
        product_like: {
          action: 'liked',
          icon: 'mdiHeart',
          card_action: 'published',
          object: 'story'
        },
        assetsasset_like: {
          action: 'liked',
          icon: 'mdiHeart',
          card_action: 'added',
          object: 'illustration'
        },
        asset_like: {
          action: 'liked',
          icon: 'mdiHeart',
          card_action: 'added',
          object: 'illustration'
        },
        assetsvg_like: {
          action: 'liked',
          icon: 'mdiHeart',
          card_action: 'added',
          object: 'illustration'
        },
        sound_like: {
          action: 'liked',
          icon: 'mdiHeart',
          card_action: 'added',
          object: 'sound'
        },
        assetssound_like: {
          action: 'liked',
          icon: 'mdiHeart',
          card_action: 'added',
          object: 'sound'
        },
        remix: {
          action: 'remixed',
          icon: 'mdiCached',
          card_action: 'published',
          object: 'story'
        },
        use_art: {
          action: 'contributed',
          icon: 'mdiPuzzle',
          card_action: 'published',
          object: 'story'
        }
      }
    }
  },
  computed: {
    actList: function() {
      return this.activity.activities
    },
    contribMore: function() {
      return this.activity.activities.length - 2
    },
    getShare: function() {
      let description, title
      title = this.getObject(0).title + ' | Elementari'
      if (this.getObject(0).synoposis) {
        description = this.getObject(0).synoposis
      } else {
        description = this.$t('feed.share.description')
      }

      let shareData = {
        url:
          window.location.protocol +
          '//' +
          window.location.hostname +
          this.getObject(0).get_absolute_url,
        title: title,
        description: description,
        quote: description,
        media: this.getObject(0)._thumbnail
      }
      return shareData
    },
    getDescription: function() {
      var count = 1
      if (this.headerList.includes(this.activity.verb)) {
        const card_action = this.description[this.activity.verb]['card_action']
        if (
          this.activity.verb != 'remix' &&
          this.activity.verb != 'product' &&
          this.activity.verb != 'use_art'
        ) {
          // count = this.activity.activity_count
        }
        const object = this.description[this.activity.verb]['object']
        return (
          this.$t('feed.activity.' + card_action) +
          ' ' +
          this.$tc('feed.activity.' + object, count)
        )
      } else {
        const action = this.description[this.activity.verb]['action']
        if (this.activity.verb != 'remix' && this.activity.verb != 'product') {
          count = this.activity.activity_count
        }
        const object = this.description[this.activity.verb]['object']
        return (
          this.$t('feed.activity.' + action) +
          ' ' +
          this.$tc('feed.activity.' + object, count)
        )
      }
    },
    getAction: function() {
      if (this.description[this.activity.verb]) {
        return this.$tc(
          'feed.activity.' + this.description[this.activity.verb]['action'],
          this.activity.activities.length
        )
      } else {
        return ''
      }
    },
    getIcon: function() {
      if (this.description[this.activity.verb]) {
        return this.$vuetify.icons.values[
          this.description[this.activity.verb]['icon']
        ]
      }
      return ''
    },
    getIconColor: function() {
      if (!this.description[this.activity.verb]) return

      if (this.description[this.activity.verb]['icon'] == 'mdiPuzzle')
        return 'green'

      return 'red'
    },
    getCardUser: function() {
      if (this.hasHeader()) {
        if (this.actList[0].object_user) {
          return this.actList[0].object_user
        }
      } else {
        if (this.actList[0].actor) {
          return this.actList[0].actor
        }
      }
      return ''
    },
    getTime: function() {
      const time = this.$dayjs().to(this.activity.updated_at)
      return time
    }
  },
  methods: {
    isObject(value) {
      return value !== null && typeof value === 'object';
    },
    hasHeader() {
      if (this.headerList.includes(this.activity.verb)) {
        return true
      }
    },
    getObject(index) {
      const verb = this.activity.verb
      let obj = null
      if (verb.includes('productsproduct_like') || verb.includes('product_like')){
        obj = this.actList[index].target
      }
      else if (verb.includes('remix') || verb.includes('product')) {
        obj = this.actList[index].object
      } else {
        obj = this.actList[index].target
      }
      if (typeof obj === 'string' || obj instanceof String) {
        return false
      } else {
        return obj
      }
    }
  }
}
</script>

<style>
.more-container {
  background-color: rgba(0, 0, 0, 0.4);
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  color: #fff;
  z-index: 10;
}
</style>
